import React from 'react';
import MUIDataTable from 'mui-datatables';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// @material-ui/core components
import { MuiThemeProvider } from '@material-ui/core/styles';

// styles
import Mytheme from './Muitheme_Modified.jsx';

// @material-ui/icons
import Assignment from '@material-ui/icons/Assignment';

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
var dateFormat = require('dateformat');

const styles = {
  cardIconTitle: {
    color: '#000 !important',
    marginTop: '10px',
    marginBottom: '0px'
  },
  successicons: {
    color: 'green'
  }
};
class Employmentdetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: []
    };
  }

  componentWillMount() {
    var documents = [];
    var self = this;

    var employement = this.props.user.Employment;

    Object.keys(employement).forEach(function(key) {
      documents.push([
        employement[key].employee_id,
        employement[key].organization_name,
        employement[key].document_name,
        employement[key].department,
        employement[key].designation,

        dateFormat(
          new Date(parseInt(employement[key].joining_date, 10)),
          'dd/mm/yyyy'
        ),
        !employement[key].end_date
          ? '-'
          : dateFormat(
              new Date(parseInt(employement[key].end_date, 10)),
              'dd/mm/yyyy'
            )
      ]);
    });
    self.setState({
      documents: documents
    });
  }

  render() {
    const { classes } = this.props;
    const options = {
      filterType: 'dropdown',
      responsive: 'stacked',
      fixedHeader: true,
      selectableRows: false
    };
    // declaring the column name
    const columns = [
      {
        name: 'Employee Id',
        options: {
          filter: false,
          sort: false,
          download: false
        }
      },
      {
        name: 'Organization Name',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Document Name',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Department',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'Designation',
        options: {
          filter: true,
          sort: true
        }
      },

      {
        name: 'Join Date',
        options: {
          filter: true,
          sort: true
        }
      },
      {
        name: 'End Date',
        options: {
          filter: true,
          sort: true
        }
      }
    ];
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} lg={12} />
        <Card>
          <CardHeader color='info' icon>
            <CardIcon color='info'>
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Employment Details</h4>
          </CardHeader>
          <CardBody>
            <MuiThemeProvider theme={Mytheme}>
              <MUIDataTable
                title={''}
                data={this.state.documents}
                columns={columns}
                options={options}
              />
            </MuiThemeProvider>
          </CardBody>
        </Card>
      </GridContainer>
    );
  }
}
Employmentdetails.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withStyles(styles)(Employmentdetails);



// WEBPACK FOOTER //
// ./src/Container/Document/Employment/Employmentdetails.jsx